import queryString from 'querystring'

import { useLocation } from '@reach/router'
import { Script } from 'gatsby'
import React, { Fragment, useState } from 'react'
import styled from 'styled-components'

import { navigationVars } from '../helpers/navigationVars'
import theme from './atoms/theme'
import ErrorBoundary from './molecules/error-boundary'
import Footer from './organisms/footer'
import InteractiveFooter from './organisms/interactiveFooter'
import InteractiveNavigation from './organisms/interactiveNavigation'
import Navigation from './organisms/navigation'

require('./base.css')
require('./inter.css')
require('plyr-react/plyr.css')

interface LayoutContainerProps {
  noTop?: boolean
  isInteractive?: boolean
  hasVisibleNotification?: boolean
}

const LayoutContainer = styled.div<LayoutContainerProps>`
  margin-top: ${(props): string =>
    props.noTop || props.isInteractive
      ? '0'
      : props.hasVisibleNotification
        ? navigationVars.mobileWithNotificationHeight
        : navigationVars.mobileHeight};
  @media only screen and ${theme.breakpoints.fromNormalScreen} {
    margin-top: ${(props): string =>
      props.noTop || props.isInteractive
        ? '0'
        : props.hasVisibleNotification
          ? navigationVars.desktopWithNotificationHeight
          : navigationVars.desktopHeight};
  }
`

type LayoutPropTypes = {
  children: React.ReactNode
  isInteractive?: boolean
  noTop?: boolean
}

const Layout = (props: LayoutPropTypes): JSX.Element => {
  const { children, noTop, isInteractive } = props
  const location = useLocation()
  const query = queryString.parse(location.search, '?')
  const isSimple = query.simple
  const [hasVisibleNotification, setHasVisibleNotification] = useState(false)
  const handleNotification = (
    showingNotification: boolean | ((prevState: boolean) => boolean),
  ) => {
    setHasVisibleNotification(showingNotification)
  }

  return (
    <Fragment>
      <Script
        id='first-unique-id'
        // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
        dangerouslySetInnerHTML={{
          __html: `(function(e,t,o,n,p,r,i){e.visitorGlobalObjectAlias=n;e[e.visitorGlobalObjectAlias]=e[e.visitorGlobalObjectAlias]||function(){(e[e.visitorGlobalObjectAlias].q=e[e.visitorGlobalObjectAlias].q||[]).push(arguments)};e[e.visitorGlobalObjectAlias].l=(new Date).getTime();r=t.createElement("script");r.src=o;r.async=true;i=t.getElementsByTagName("script")[0];i.parentNode.insertBefore(r,i)})(window,document,"https://diffuser-cdn.app-us1.com/diffuser/diffuser.js","vgo");
   vgo('setAccount', '226255163');
   vgo('setTrackByDefault', true);
   vgo('process');`,
        }}
      />
      {isInteractive ? (
        <InteractiveNavigation isSimple={isSimple === 'true'} />
      ) : (
        <Navigation onNotification={handleNotification} />
      )}
      <LayoutContainer
        noTop={noTop}
        isInteractive={isInteractive}
        hasVisibleNotification={hasVisibleNotification}
      >
        <ErrorBoundary>{children}</ErrorBoundary>
      </LayoutContainer>
      {isInteractive ? (
        <InteractiveFooter isSimple={isSimple === 'true'} />
      ) : (
        <Footer />
      )}
    </Fragment>
  )
}

export default Layout
